import { React } from "react";
import HiredCandidatesHeader from "./HiredCandidatesHeader";
import HiredCandidateFilter from "./HiredCandidateFilter";

export default function HiredCandidatesPage() {
  return (
    <>
      <HiredCandidatesHeader />

      <HiredCandidateFilter />
    </>
  );
}
